import { ISidenavMenuItem } from './sidenav-menu-item.interface';

/**
 * A class to represent a sidenav menu item
 */
export class SidenavMenuItem implements ISidenavMenuItem {
  public type = 'menu-item';

  // constructor
  constructor(public label: string, public route: string) {}
}
